/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <b-breadcrumb :items="breadcrumbItems" />
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    breadcrumbItems () {
      // check if last is setted
      const _items = [...this.items]
      if (_items && _items.length && !_items[_items.length - 1].to) {
        _items[_items.length - 1].to = this.$route.path
      }
      this.$store.commit('ui/setBreadcrumb', _items)
      return this.items
    }
  }
}
</script>
